module.exports = ["zojuist",["%s seconde geleden","%s seconden geleden"],["%s minuut geleden","%s minuten geleden"],"%s uur geleden",["%s dag geleden","%s dagen geleden"],["%s week geleden","%s weken geleden"],["%s maand geleden","%s maanden geleden"],"%s jaar geleden"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/nl-NL.json
// module id = zeDA
// module chunks = 1